import _ from 'lodash';
import feathers from '@feathersjs/client';

import authentication from './authentication';
import socketio from './socketio';
import config from './config';

const app = feathers();

// Monkey-patch feathersjs to automatically add the `/api/` if you
// call `app.service` with just a service name...
app.service = function service( path ) {
  if ( ! path.startsWith( '/api' ) ) path = `/api/${path}`;
  path = path.replace( /^(\/+)|(\/+)$/gu, '' ) || '/';
  const current = this.services[ path ];

  if ( current ) return current;

  if ( ! _.isFunction( this.defaultService ) ) return;
  this.use( `/${path}`, this.defaultService( path ) );
  return this.services[ path ];
};

app.configure( config );
app.configure( feathers.socketio( socketio ) );
app.configure( authentication() );

export default app;
